import { computed, action, makeObservable } from 'src_common/common/mobx-wrapper';
import { ConversionFn, Result, ResultError, ResultValue } from './type';

export interface ValueType {
    setAsVisited: () => void;
    modifiedStatus: boolean;
    isVisited: boolean;
    reset: () => void;
}

/**
 * @deprecated - Please use src_common/common/mobx-utils/Form2/FormModel.ts
 */
export class FormModel<V> {
    private inner: ValueType;
    private getValue: () => Result<V>;

    public constructor(prev: ValueType, getValue: () => Result<V>) {
        this.inner = prev;
        this.getValue = getValue;
        makeObservable(this);
    }

    public map<C>(conv: ConversionFn<V, C>): FormModel<C> {
        return new FormModel(this, (): Result<C> => {
            const valueModel = this.getValue();
            return valueModel instanceof ResultValue ? conv(valueModel.value) : valueModel;
        });
    }

    @action public setAsVisited(): void {
        this.inner.setAsVisited();
    }

    @computed public get result(): Result<V> {
        return this.getValue();
    }

    @computed public get modifiedStatus(): boolean {
        return this.inner.modifiedStatus;
    }

    @computed public get errorMessage(): string | null {
        if (this.inner.isVisited === false) {
            return null;
        }

        const result = this.result;

        if (result instanceof ResultError && result.shouldBeShow) {
            return result.message;
        }

        return null;
    }

    public get isVisited(): boolean {
        return this.inner.isVisited;
    }

    @action public reset(): void {
        this.inner.reset();
    }
}
